import styled from "styled-components";

import CompactTable from "../../../../../../../../CompactTable";

const Root = styled(CompactTable)`
	.rs-table-row:not(.rs-table-row-header) {
		&.selected {
			background-color: #f2faff;

			.rs-table-cell-content {
				background-color: #f2faff;
			}
		}
	}
`;

export default Root;
